

import printModel from '../../../3dapps/mixins/printModel';
import { baseURL } from "../../../request/request";
import { createPosedClone } from '../../../3dapps/js/exportSkinnedMesh';
import { surfaceOfGeometry, volumeOfGeometry, bboxOfGroup } from '../../../3dapps/js/calcSize';
import * as THREE from 'three'

import { initThree, camera, renderer, scene } from './makeModel';
import SkinnedBinLoader from './SkinnedBinLoader';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'

import loading from '@/components/loading';
import SourceExporter from './SourceExporter';



var boneOriginData = [];

var currentMesh = null; 
var hairMesh = null; 
var headMesh = null; 
var headSkeleton = null; 
let originWidth = 0; 


var hairMeshList = {}; 

const NOSE_TIP_INDEX = 3;
const NOSE_TIP_UP_1_INDEX = 4;
const NOSE_TIP_UP_2_INDEX = 5;
const NOSE_TIP_UP_3_INDEX = 6;
const NOSE_TIP_BOTTOM_1_INDEX = 7;
const NOSE_TIP_BOTTOM_2_INDEX = 8;

const MOUSE_CENTER_INDEX = 9;
const MOUSE_LEFT_1_INDEX = 10;
const MOUSE_LEFT_2_INDEX = 11;
const MOUSE_RIGHT_1_INDEX = 12;
const MOUSE_RIGHT_2_INDEX = 13;

var btnsListIndex = 0;


function updateModel() {
if (currentMesh) {
scene.remove(currentMesh);
currentMesh = null;
}
currentMesh = new THREE.Group();
console.log("mesh", currentMesh);
scene.add(currentMesh);
}

export default {
name: "headPortrait",
mixins: [printModel],
components: {
XDialog,
range: Range,
loading
},
data() {
return {
quotationName: "3d人头像",
productType: "3d人头像",
landscape: true,//竖屏状态要一直为true
showPrint: false,
tabTitle: ['人脸', '头发', '五官'],
cur: 0, //默认选中第一个tab
showTabList: true, //默认展示
showSize: false,
facesList: ["添加正面照", "添加左侧照", "添加右侧照"],

draw: {
width: 80,
height: 1,
thickness: 2,
}, //尺寸
facesImg: ["", "", ""],
facesUid: ["", "", ""],
facesImgLen: false,
showLoading: false, //加载
obj_uid: '',
hairList: [],
hair_id: '',
eye: 0,
nose: 0,
mouth: 0,
min: -100,
max: 100,
mouthMin: -100,
mouthMax: 60,
disabled: true,
addCartIndex: -1,
orderIndex: -1,
btnsList: [{
class: "btn_left",
isClick: true,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "编辑",
}, {
class: "btn_content",
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "尺寸",
}], //按钮列表

}
},

mounted() {
const scope = this;
this.showLoading = true;
console.log("showLoading", this.showLoading);

var mo = function (e) {
e.preventDefault();
}


scope.$nextTick(function () {
scope.$refs.headPortrait.style.paddingTop = '0px';
scope.$refs.headPortrait.style.overflow = 'hidden';
});

initThree(scope.$refs.canvas);

updateModel();



const contentDOM = scope.$refs.headPortrait;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 


camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}
scope.init3d(contentDOM, camera, renderer, resize1);

this.$nextTick(function () {
scope.loadData();
});

console.log('get hair list');

this.$request.post('/headPortrait/getHairList', {}).then(res => {
console.log("res", res);
if (res.code === 0 && !res.obj.error_message) {

scope.hairList = res.obj;








}
scope.showLoading = false;
}).catch(err => {
scope.showLoading = false;
console.error("get hair list err", err);
scope.$vux.toast.show({
type: 'cancel',
text: err.msg
})
console.log(err);
})
},

methods: {

loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("headPortrait");
localStorage.removeItem("headPortrait"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.draw.width = data.width;
scope.draw.height = data.height;
scope.draw.thickness = data.thickness;
scope.cur = data.cur;
scope.facesImg = data.facesImg;
scope.eye = data.eye;
scope.nose = data.nose;
scope.mouth = data.mouth;
scope.hair_id = data.hair_id;
scope.obj_uid = data.obj_uid;
scope.facesImg = data.facesImg;
scope.hairList = data.hairList;


scope.showLoading = true;

setTimeout(function () {
scope.showLoading = true;

if (hairMesh) {
currentMesh.remove(hairMesh);
hairMesh.traverse(function (obj) {
if (obj.isMesh) {
obj.geometry.dispose();
}
});
hairMesh = null;
console.log("hairMesh", hairMesh);
}

let url = `${baseURL}/headPortrait/getFullHeadSkinned/${scope.obj_uid}`;

let material = new THREE.MeshPhongMaterial({
color: 0xffffff,
skinning: true
});
new SkinnedBinLoader().load(url, function (geom, skeleton) {
let mesh = new THREE.SkinnedMesh(geom, material); 
for (let bone of skeleton.bones) {
mesh.add(bone);
}
mesh.bind(skeleton);
headMesh = mesh;
currentMesh.add(mesh);

scope.showTabList = false;
scope.resize();
scope.disabled = false;
headSkeleton = skeleton;
boneOriginData = [];
for (let i = 0; i < skeleton.bones.length; i++) {
let bone = skeleton.bones[i];
boneOriginData[i] = {
scale: new THREE.Vector3().copy(bone.scale),
position: new THREE.Vector3().copy(bone.position),
};
}
console.log(boneOriginData);


let box = new THREE.Box3().expandByObject(mesh);
let size = box.getSize();
originWidth = size.x;
console.log('orginwidth', originWidth);
let scale = scope.draw.width / originWidth;
currentMesh.scale.set(scale, scale, scale);
});

let url_hair = `${baseURL}/headPortrait/getHair/${scope.obj_uid}/${scope.hair_id}`;
new THREE.OBJLoader().load(url_hair, function (obj) {
let old_hairMesh = hairMesh;
hairMesh = obj;
hairMesh.children[0].material = new THREE.MeshLambertMaterial({
color: 0x808080,
ransparent: true,
opacity: 1,
});
currentMesh.add(hairMesh);


setTimeout(function () {
if (old_hairMesh) {
currentMesh.remove(old_hairMesh);
old_hairMesh.traverse(function (obj) {
if (obj.isMesh) {
obj.geometry.dispose();
}
});
}
scope.$set(scope.btnsList[0], `isClick`, !scope.btnsList[0].isClick);
scope.showLoading = false;
scope.resize();
}, 1500);
});
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};
data.width = this.draw.width;
data.height = this.draw.height;
data.thickness = this.draw.thickness;
data.cur = this.cur;
data.facesImg = this.facesImg;
data.eye = this.eye;
data.nos = this.nose;
data.mouth = this.mouth;
data.hair_id = this.hair_id;
data.obj_uid = this.obj_uid;
data.facesImg = this.facesImg;
data.hairList = this.hairList;

localStorage.setItem("headPortrait", JSON.stringify(data));
}
},


btnIdChange(index) {
if (btnsListIndex === index) {
this.$set(this.btnsList[index], `isClick`, !this.btnsList[index].isClick);
} else {
this.$set(this.btnsList[btnsListIndex], `isClick`, false);
this.$set(this.btnsList[index], `isClick`, true);
btnsListIndex = index;
}

if (index === 0) {
this.showTabList = !this.showTabList;
this.showSize = false;
} else {
this.showSize = !this.showSize;
this.showTabList = false;
}

this.resize();
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.showTabList) {
let tabHeight = h * 0.2; 
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
},


selectHairItem(hair_id) {
const scope = this;
let obj_uid = this.obj_uid;
if (!obj_uid || headMesh == null) {
scope.$vux.toast.show({
type: 'cancel',
text: "请生成人脸模型!"
})
return;
}

this.showLoading = true;

let url = `${baseURL}/headPortrait/getHair/${obj_uid}/${hair_id}`;
new THREE.OBJLoader().load(url, function (obj) {
let old_hairMesh = hairMesh;
hairMesh = obj;
hairMesh.children[0].material = new THREE.MeshLambertMaterial({
color: 0x808080,
ransparent: true,
opacity: 1,
});
currentMesh.add(hairMesh);


setTimeout(function () {
if (old_hairMesh) {
currentMesh.remove(old_hairMesh);
old_hairMesh.traverse(function (obj) {
if (obj.isMesh) {
obj.geometry.dispose();
}
});
}

scope.hair_id = hair_id;

scope.showLoading = false;
scope.resize();
}, 1500);

});
},


handelUp(e, index) {
this.index = index;
this.upImg(e);
},


upImg(e) {
const scope = this;

let file = e.target.files[0];
if (!file) return;

this.showLoading = true;
scope.addImage(file);
console.log("e.target.files", e.target.files);
e.target.value = ''; 
},


delImg(index) {
const scope = this;
scope.facesImg.splice(index, 1, "");
scope.facesUid.splice(index, 1, "");
console.log("index", index);
console.log("facesImg", scope.facesImg);
if (!this.facesUid[0]) {
this.facesImgLen = false;
}
},


calcAngle(yaw_angle) {
let left_angle = Math.abs(50 - yaw_angle);
let center_angle = Math.abs(0 - yaw_angle);
let right_angle = Math.abs(-50 - yaw_angle);

let angleArr = [center_angle, left_angle, right_angle];

let min = angleArr[0];

let index = 0;
for (let i = 0; i < angleArr.length; i++) {
if (min > angleArr[i]) {
min = angleArr[i];
index = i;
}
}
return index;
},


addImage(file) {
const scope = this;
console.log("scope.facesImg", scope.facesImg);
let formData = new FormData();
formData.append("img", file);
this.$request.post('/headPortrait/addImage', formData).then(res => {
console.log("res", res);
if (res.code === 0 && res.obj.face_num > 1) {
scope.showLoading = false;
scope.$vux.toast.show({
type: 'cancel',
text: "请上传单人照！"
})
return;
}
if (res.code === 0 && res.obj.faces.length !== 0) {
let obj = res.obj;


let index = scope.index;
console.log("scope.facesImg", scope.facesImg);

scope.facesUid[index] = obj.img_uid;
let facesImg = window.URL.createObjectURL(file);
scope.facesImg[index] = facesImg;


if (scope.facesImg[0]) {
scope.facesImgLen = true;
}

scope.$forceUpdate();
} else {
scope.$vux.toast.show({
type: 'cancel',
text: "请重新上传照片！"
})
}
scope.showLoading = false;
}).catch(err => {
scope.showLoading = false;
console.log(err);
scope.$vux.toast.show({
type: 'cancel',
text: err.msg
})
})
},


buildFace() {
const scope = this;

if (hairMesh) {
currentMesh.remove(hairMesh);
hairMesh.traverse(function (obj) {
if (obj.isMesh) {
obj.geometry.dispose();
}
});
hairMesh = null;
console.log("hairMesh", hairMesh);
}


if (headMesh) {
currentMesh.remove(headMesh);
headMesh.geometry.dispose();
headMesh = null;
}

headSkeleton = null;

let formData = new FormData();
let faceReady = this.facesUid;
if (!faceReady[0]) {
scope.$vux.toast.show({
type: 'cancel',
text: "请上传正面照图片!"
})
return;
}

this.showLoading = true;

console.log(faceReady);
formData.append("img_uid_1", faceReady[0]);
if (faceReady[1]) { formData.append("img_uid_2", faceReady[1]); }
if (faceReady[2]) { formData.append("img_uid_3", faceReady[2]); }
this.$request.post('/headPortrait/buildFace', formData).then(res => {
if (res.code === 0 && !res.obj.error_message) {
console.log("res", res);
let obj_uid = res.obj.obj_uid;
scope.obj_uid = obj_uid;


let url = `${baseURL}/headPortrait/getFullHeadSkinned/${obj_uid}`;

let material = new THREE.MeshPhongMaterial({
color: 0xffffff,
skinning: true
});

new SkinnedBinLoader().load(url, function (geom, skeleton) {
let mesh = new THREE.SkinnedMesh(geom, material); 
for (let bone of skeleton.bones) {
mesh.add(bone);
}
mesh.bind(skeleton);



let box = new THREE.Box3().expandByObject(mesh);
currentMesh.add(mesh);
headMesh = mesh;

headMesh = mesh;
scope.hair_id = "hair-001";
scope.selectHairItem("hair-001");
scope.showTabList = false;
scope.resize();
scope.disabled = false;
headSkeleton = skeleton;

boneOriginData = [];
for (let i = 0; i < skeleton.bones.length; i++) {
let bone = skeleton.bones[i];
boneOriginData[i] = {
scale: new THREE.Vector3().copy(bone.scale),
position: new THREE.Vector3().copy(bone.position),

};
}
console.log(boneOriginData);


let size = box.getSize();
originWidth = size.x;
console.log('orginwidth', originWidth);
let scale = scope.draw.width / originWidth;
currentMesh.scale.set(scale, scale, scale);
}, null, function () {
console.log("parse failed");
});
}
this.$set(this.btnsList[0], `isClick`, !this.btnsList[0].isClick);
scope.showLoading = false;
}).catch(err => {
this.$set(this.btnsList[0], `isClick`, !this.btnsList[0].isClick);
scope.showLoading = false;
scope.$vux.toast.show({
type: 'cancel',
text: err.msg
})
console.log(err);
})
},


updatedData() {
let width = this.draw.width;
if (width == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (width < 20) {
this.$vux.toast.show({
text: '最小宽高为20毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (width > 300) {
this.$vux.toast.show({
text: '最大宽高为300毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
}
setTimeout(() => {

let scale = this.draw.width / originWidth;
currentMesh.scale.set(scale, scale, scale);
this.showLoading = false;
}, 50);
},


touchstart() {
this.btnsListIndex = -1;
this.showSize = false;
this.showTabList = false;
this.updatedData();
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.resize();
},


onEyeChange(val) {

let scale = Number(val) * 0.01;
let sx = 1.0 + 0.1 * scale;
let sy = 1.0 + 0.3 * scale;
headSkeleton.bones[1].scale.set(sx, sy, 1.0);
headSkeleton.bones[2].scale.set(sx, sy, 1.0);
},


onNoseChange(val) {

let scale = Number(val) * 0.01;
let sx = 1.0 + 0.1 * scale;
let sy = 1.0 + 0.1 * scale;
let sz = 1.0 + 0.3 * scale;

headSkeleton.bones[NOSE_TIP_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[NOSE_TIP_INDEX].position.z = boneOriginData[NOSE_TIP_INDEX].position.z + 3 * scale;
headSkeleton.bones[NOSE_TIP_BOTTOM_1_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[NOSE_TIP_BOTTOM_1_INDEX].position.z = boneOriginData[NOSE_TIP_BOTTOM_1_INDEX].position.z + 3 * scale;
headSkeleton.bones[NOSE_TIP_UP_1_INDEX].scale.set(scale > 0 ? 1.0 - 0.1 * scale : 1.0, sy, sz);
headSkeleton.bones[NOSE_TIP_UP_1_INDEX].position.z = boneOriginData[NOSE_TIP_UP_1_INDEX].position.z + 6 * scale;
headSkeleton.bones[NOSE_TIP_UP_2_INDEX].scale.set(scale > 0 ? 1.0 - 0.1 * scale : 1.0, sy, sz);
},


onMouthChange(val) {

let scale = Number(val) * 0.01;
let sx = 1.0 + 0.3 * scale;
let sy = 1.0 + 0.1 * scale;
let sz = 1.0 + 0.1 * scale;
headSkeleton.bones[MOUSE_CENTER_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[MOUSE_LEFT_1_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[MOUSE_LEFT_2_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[MOUSE_RIGHT_1_INDEX].scale.set(sx, sy, sz);
headSkeleton.bones[MOUSE_RIGHT_2_INDEX].scale.set(sx, sy, sz);
},


isSure() {
this.showLoading = true;
this.showSize = false;
this.btnsList[1].isClick = false;
this.updatedData();
},


canelPop() {
this.showSize = false;
this.updatedData();
this.$set(this.btnsList[1], `isClick`, !this.btnsList[1].isClick);
},


/********************************* 打印相关 ***********************************/

print() {

this.showSize = false;
this.showLoading = true;
console.log("currentMesh", currentMesh);
if (currentMesh.children.length === 0) {
this.showLoading = false;
this.$vux.toast.show({
text: '请生成人脸模型！',
type: "warn",
time: 2000,
position: "middle",
});
return;
}



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
console.log("display:none 0就不显示", this.total);
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
console.log("1就是显示");
}

if (currentMesh) {












this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
setTimeout(() => {
const scope = this;
scope.showLoading = false;
}, 50);
});

} else {
this.$vux.toast.show({
text: '3D人头像不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d();
this.showLoading = false;
}
},

getUploadUrl() {
return "/headPortrait/makeModel";
},

makeStlBlob() {
let group = this.getModelToPrint();
let sourceExporter = new SourceExporter();
let blob = sourceExporter.makeBlob(group);
return blob;
},


getModelToPrint() {
let group = new THREE.Group();
group.add(hairMesh.clone());
group.add(createPosedClone(headMesh, headSkeleton));
group.scale.copy(currentMesh.scale);
group.updateMatrix();
return group;
},

calcModelSize() {
let group = this.toExportModel;
console.log(group);
group.updateWorldMatrix(false, true);
let hair = group.children[0].children[0];
let head = group.children[1];
hair.updateWorldMatrix(false, false);
let volume1 = volumeOfGeometry(hair.geometry, hair.matrixWorld);
head.updateWorldMatrix(false, false);
let surface2 = surfaceOfGeometry(head.geometry, head.matrixWorld);
let volume2 = surface2 * this.draw.thickness; 
let volume = volume1 + volume2;
console.log("volume", volume1, surface2, volume2);

this.toExportModelSize = {
box3: bboxOfGroup(group),
volume
};
let box = this.toExportModelSize.box3;

const EPS = 0.01; 

this.length = Math.max(1, Math.round(Math.abs(box.max.x - box.min.x) - EPS));
this.width = Math.max(1, Math.round(Math.abs(box.max.y - box.min.y) - EPS));
this.height = Math.max(1, Math.round(Math.abs(box.max.z - box.min.z) - EPS));
this.volume = Math.max(1, Math.round(this.toExportModelSize.volume - EPS));
},
},
}


// WEBPACK FOOTER //
// ./src/views/headPortrait3d/scripts/index.js